import styled from 'styled-components'

export const Container = styled.div`
  padding: 0 2rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`
